import axios from "axios";
import { toast } from "sonner";
import { API } from "./api";
import { apiErrorMessage } from "./formHelpers";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export const startGoogleLogin = (destination = "reviews") => {
  const path = destination === "admin" ? "/admin" : "/";
  const redirectUrl = window.location.origin + path;
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
};

export const googleDestination = (isAdmin) => isAdmin ? "/admin" : "/";

export const googleSessionExchange = (cache, sessionId, isAdmin) => {
  const key = `${googleDestination(isAdmin)}:${sessionId}`;
  if (cache.current?.key === key) return cache.current.promise;
  const endpoint = isAdmin ? "/auth/google/session" : "/visitor/session";
  const promise = axios.post(`${API}${endpoint}`, { session_id: sessionId }, { withCredentials: true });
  cache.current = { key, promise };
  return promise;
};

export const completeGoogleLogin = (data, isAdmin, navigate) => {
  if (!isAdmin) {
    window.dispatchEvent(new CustomEvent("pepe:visitor", { detail: data }));
    sessionStorage.setItem("pepe_scroll_avis", "1");
  }
  const greeting = isAdmin ? "Bienvenue dans l'espace Pépé !" : `Connecté avec Google — bienvenue ${data.first_name || ""} !`;
  toast.success(greeting);
  navigate(googleDestination(isAdmin), { replace: true });
};

export const rejectGoogleLogin = (error, isAdmin, navigate) => {
  const message = apiErrorMessage(error, "Connexion Google impossible, réessaie");
  if (!isAdmin) toast.error(message);
  navigate(googleDestination(isAdmin), { replace: true, state: { authError: message } });
};